<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="30%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle :title="pageTitle" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form" v-model="valid"
          >
          <template v-if="dayType == false">
            <v-row class="formHeight">
              <div class="cardWrap__fromArea__title">日付</div>
              <v-col cols="12" sm="3">
                <v-text-field
                placeholder="01-01"
                type="tel"
                inputmode="tel"
                v-model="fromSetData.month_day"
                maxlength="5"
                validate-on-blur
                :rules="[actionrules.checkEmpty,
                         actionrules.checkDateFormat,
                         actionrules.checkCorrectDate]"
                required
                />
              </v-col>
            </v-row>
          </template>
          <template v-if="dayType == true">
            <v-row class="formHeight">
              <div class="cardWrap__fromArea__title">月</div>
              <v-col cols="12" sm="3">
                <v-select
                  :items="monthDaySelectList"
                  class="mr-auto pt-4"
                  item-value="code"
                  item-text="name"
                  dense
                  v-model="fromSetData.month"
                  validate-on-blur
                  :rules="[actionrules.checkEmpty]"
                />
              </v-col>
            </v-row>
            <v-row class="formHeight">
              <div class="cardWrap__fromArea__title">第</div>
              <v-col cols="12" sm="3">
                <v-select
                :items="weekSelectList"
                class="mr-3 pt-4"
                item-value="code"
                item-text="name"
                dense
                v-model="fromSetData.week"
                validate-on-blur
                :rules="[actionrules.checkEmpty]"
                required
                />
              </v-col>
            </v-row>
            <v-row class="formHeight">
              <div class="cardWrap__fromArea__title">曜日</div>
              <v-col cols="12" sm="3">
                <v-select
                  class="mr-3 pt-4"
                  :items="weekDaySelectList"
                  item-value="code"
                  item-text="name"
                  dense
                  v-model="fromSetData.weekDay"
                  validate-on-blur
                  :rules="[actionrules.checkEmpty]"
                ></v-select>
              </v-col>
            </v-row>
          </template>
          <template>
            <v-row class="formHeight">
              <div class="cardWrap__fromArea__title">祝日名称</div>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="fromSetData.date_name"
                  validate-on-blur
                  type="text"
                  :rules="[actionrules.checkEmpty]"
                  required
                />
              </v-col>
            </v-row>
          </template>
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <v-btn color="green darken-4" text v-if="addModeStatus" @click="RegistHoliday">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="UpdateHoliday">変更</v-btn>
      </v-card-actions>
      <AddOverlay
        page-name="祝日"
        @processing="RegistHoliday"
        @cancel="addOverlay = !addOverlay"
        :dblclickStop="processing"
        :process-result="process"
        :OverlaySwitch="addOverlay"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import AddOverlay from '@/views/Master/page/overlay/AddOverlay';
import { UPDATE_SETTING_DAYS, REGISTER_SETTING_DAYS } from '@/constants/setting_days';
import validater from '../../../../lib/validater';
import { CODE_MASTER } from '../../../config';

export default {
    components: {
        CardTitle,
        AddOverlay
    },
    data () {
        return {
            pageTitle: null,
            dialog: false,
            changeModeStatus: false,
            addModeStatus: false,
            processing: false,
            addOverlay: false,
            // エラーメッセージ
            error: '',
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            dayType: true,
            selectDateType: null,
            old_month_day: null,
            old_date_name: null,
            weekDaySelectList: [
                { code: '00', name: '日曜日' },
                { code: '01', name: '月曜日' },
                { code: '02', name: '火曜日' },
                { code: '03', name: '水曜日' },
                { code: '04', name: '木曜日' },
                { code: '05', name: '金曜日' },
                { code: '06', name: '土曜日' }
            ],
            monthDaySelectList: [
                { code: '01', name: '1' },
                { code: '02', name: '2' },
                { code: '03', name: '3' },
                { code: '04', name: '4' },
                { code: '05', name: '5' },
                { code: '06', name: '6' },
                { code: '07', name: '7' },
                { code: '08', name: '8' },
                { code: '09', name: '9' },
                { code: '10', name: '10' },
                { code: '11', name: '11' },
                { code: '12', name: '12' }
            ],
            weekSelectList: [
                { code: '01', name: '1' },
                { code: '02', name: '2' },
                { code: '03', name: '3' },
                { code: '04', name: '4' },
                { code: '05', name: '5' },
                { code: '06', name: '6' }
            ],
            taxType: [],
            menu: false,
            valid: false,
            actionrules: {
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any'),
                checkHalfWidthDigit: value => validater.checkHalfWidthDigit(value) || this.$t('error.validation.required.incorrect'),
                checkCorrectDate: value => this.CheckCorrectDate(value) || this.$t('error.validation.date.Correct'),
                checkDateFormat: value => validater.checkDateFormatByHolidayModal(value) || this.$t('error.validation.date.Correct')
            },
            fromSetData: {
            }
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addModeStatus = false;
            this.changeModeStatus = false;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.old_month_day = null;
            this.old_date_name = null;
            this.fromSetData = {
                month_day: '',
                date_name: '',
                month: '',
                week: '',
                weekDay: ''
            };
        },
        /** ----------------------------------------------
         * 変更
         * ---------------------------------------------- */
        UpdateHoliday: async function () {
            if (this.$refs.form.validate()) {
                try {
                    if (this.selectDateType === CODE_MASTER.DATE_TYPE_TARGET_DATE) {
                        this.fromSetData.month_day = this.fromSetData.month + this.fromSetData.week + this.fromSetData.weekDay;
                    }
                    this.fromSetData.month_day = this.fromSetData.month_day.replace(/-/, '');
                    await this.$apollo.mutate({
                        mutation: UPDATE_SETTING_DAYS,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            month_day: this.fromSetData.month_day,
                            date_name: this.fromSetData.date_name,
                            date_type: this.selectDateType,
                            old_month_day: this.old_month_day,
                            old_date_name: this.old_date_name
                        }
                    }).then(res => {
                        this.process.result = res.data.UpdateSettingDays.result;
                        // 登録問題なし
                        if (this.process.result === 1) {
                            this.dialog = false;
                            this.addOverlay = !this.addOverlay;
                            this.$emit('from-Dialog');
                        // 既に同じ日付で登録されていれば、エラー
                        } else if (this.process.result === 0) {
                            this.addOverlay = true;
                            this.process.resultText = this.$t('result.error.existsSettingDate');
                        }
                        this.processing = false;
                    });
                } catch (error) {
                    this.error = error;
                }
            }
        },
        /** ----------------------------------------------
         * 新規追加
         * ---------------------------------------------- */
        RegistHoliday: async function () {
            if (this.$refs.form.validate()) {
                this.processing = true;
                try {
                    if (this.selectDateType === CODE_MASTER.DATE_TYPE_TARGET_DATE) {
                        this.fromSetData.month_day = this.fromSetData.month + this.fromSetData.week + this.fromSetData.weekDay;
                    }
                    this.fromSetData.month_day = this.fromSetData.month_day.replace(/-/, '');
                    await this.$apollo.mutate({
                        mutation: REGISTER_SETTING_DAYS,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            month_day: this.fromSetData.month_day,
                            date_name: this.fromSetData.date_name,
                            date_type: this.selectDateType
                        }
                    }).then(res => {
                        this.process.result = res.data.RegisterSettingDays.result;
                        // 登録問題なし
                        if (this.process.result === 1) {
                            this.dialog = false;
                            this.addOverlay = !this.addOverlay;
                            this.$emit('from-Dialog');
                        // 既に同じ日付で登録されていれば、エラー
                        } else if (this.process.result === 0) {
                            this.addOverlay = true;
                            this.process.resultText = this.$t('result.error.existsSettingDate');
                        }
                        this.processing = false;
                    });
                } catch (error) {
                    this.error = error;
                    this.process.resultText = this.$t('result.error.add');
                }
            }
        },
        /** ----------------------------------------------
         * 実在日チェック
         * ---------------------------------------------- */
        CheckCorrectDate (value) {
            var date = new Date();
            var year = date.getFullYear();
            value = year + '-' + value;
            return validater.checkCorrectDate(value);
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        AddModal (selectDateType) {
            this.Initialize();
            this.selectDateType = selectDateType;
            // 日付指定
            if (selectDateType === CODE_MASTER.DATE_TYPE_FIXED_DATE) {
                this.dayType = false;
            // 対象日指定
            } else {
                this.dayType = true;
            }
            this.pageTitle = '日付登録';
            this.dialog = true;
            this.addModeStatus = true;
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        EditModal (item, selectDateType) {
            this.Initialize();
            this.changeModeStatus = true;
            this.selectDateType = selectDateType;
            // 日付指定
            if (selectDateType === CODE_MASTER.DATE_TYPE_FIXED_DATE) {
                this.dayType = false;
                this.fromSetData.month_day = item.monthday;
            // 対象日指定
            } else {
                this.dayType = true;
                this.fromSetData.month = item.month;
                this.fromSetData.week = item.week;
                this.fromSetData.weekDay = item.weekDay;
            }
            this.old_month_day = item.month_day;
            this.old_date_name = item.date_name;
            this.pageTitle = '日付編集';
            this.fromSetData.date_name = item.date_name;
            this.dialog = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.valid = false;
            this.dialog = false;
            this.$emit('from-Dialog');
            this.Initialize();
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

</style>
